import { IconButton } from 'component/Button/IconButton'
import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { store } from 'store/store'
import { times } from 'util/array'
import css from './Banners.module.scss'

export const Banners = observer(() => {
  const [index, setIndex] = useState(0)

  const sources = ['/banner.jpg']

  const { width, height } = store.frame
  const size = Math.min(width - 64, height - 400)
  const gap = 8
  const len = sources.length
  const left = Math.trunc(size / 2 + gap * index + size * index)

  const onLeft = useLatestCallback(() => {
    setIndex(Math.max(0, index - 1))
  })

  const onRight = useLatestCallback(() => {
    setIndex(Math.min(len - 1, index + 1))
  })

  return <Vertical className={css.root} gap={16} maxWidth="var(--max-width)" wide>
    <Space className={css.images} height={size}>
      <Space className={css.position} style={{ left: `calc(50% - ${left}px)` }} gap={gap}>
        {sources.map((source, index) => <Space key={index} className={css.image} width={size} height={size}>
          {source && <Image src={source} />}
        </Space>)}
      </Space>
    </Space>
    {sources.length > 1 && <Space gap={8} center>
      <IconButton action={onLeft}>
        <Icon size={20} name="arrow_left_alt" />
      </IconButton>
      {times(index).map(x => <div key={x} className={css.dot} />)}
      <div className={css.dash} />
      {times(len - index - 1).map(x => <div key={x} className={css.dot} />)}
      <IconButton action={onRight}>
        <Icon size={20} name="arrow_right_alt" />
      </IconButton>
    </Space>}
  </Vertical>
})
